// extracted by mini-css-extract-plugin
export default {"card":"FormContainer_card__A5G4C","container":"FormContainer_container__6PJ99","btn":"FormContainer_btn__uOHbb"};